import { createBrowserHistory } from "history"
//export let history = createBrowserHistory({ basename: '/public/react' })
export let history = createBrowserHistory({ basename: '/' })
